export default {
    HOME: 'home',
    NOTES: 'notes',
    PASSWORD_CHANGE: 'passwordChange',
    LOGIN: 'login',
    FORGOT_PASSWORD: 'forgotpassword',
    SEARCH: 'search',
    EXPORT: 'export',
    BOOKMARKS: 'bookmarks'
};
